import { render } from "./Formulari.vue?vue&type=template&id=b7d08110&scoped=true&lang=html"
import script from "./Formulari.vue?vue&type=script&lang=js"
export * from "./Formulari.vue?vue&type=script&lang=js"

import "./Formulari.vue?vue&type=style&index=0&id=b7d08110&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-b7d08110"

export default script